import { v4 as uuidv4 } from "uuid";
import { ProjectAnalyticsMembersDetailModel } from "./projectAnalyticsMembersDetailDTO";
export class ProjectAnalyticsDetailViewModel {
    constructor() {
        this.id = uuidv4();
        this.projectName = "";
        this.projectOwnerId = uuidv4();
        this.projectStartDateAsString = "";
        this.projectDueDateAsString = "";
        this.projectWorkEffortTotal = 0;
        this.projectAnalyticsMembersDetail = new ProjectAnalyticsMembersDetailModel();
    }
}
export default class ProjectAnalyticsDetailView extends ProjectAnalyticsDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
